import React, { useEffect, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import NoDataContent from '@modules/projects/projectsList/noDataContent';
import commonActions from '@flux/action/common';
import { handleLinkFromEmail } from '@modules/emailLinkRedirect/helper';

function EmailLinkRedirect(props) {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(commonActions.changeLoading(true));
    handleLinkFromEmail(history);
    return () => {
      dispatch(commonActions.changeLoading(false));
    };
  }, []);
  return (
    <div className="page-wrapper">
      <div className="project">
        <NoDataContent />
      </div>
    </div>
  );
}

export default memo(EmailLinkRedirect);
